<ng-container *ngIf="table">
  <div class="ctg-toolbar" *ngIf="showControls">
    <app-search
      class="ctg-search"
      [(ngModel)]="searchTerm"
      (ngModelChange)="onSearchChange()"
      [placeholder]="'copilot.table.filterPlaceholder' | translate"
      [attr.aria-label]="'copilot.table.filterAria' | translate"
    ></app-search>

    <span class="ctg-toolbar-spacer"></span>

    <button mat-button type="button" class="ctg-export" (click)="exportCsv()">
      <mat-icon>download</mat-icon>
      {{ 'copilot.table.exportCsv' | translate }}
    </button>
  </div>

  <ng-container *ngIf="showControls; else peopleTable">
    <div class="ctg-table-container">
      <div class="ctg-scroll">
        <mat-table
          class="ctg-table"
          [dataSource]="visibleRows"
          [style.min-width.px]="tableMinWidthPx"
          matSort
          [matSortActive]="activeSortColumn || ''"
          [matSortDirection]="activeSortDirection"
          matSortDisableClear
          (matSortChange)="onSort($event)"
        >
          <ng-container *ngFor="let col of columns" [matColumnDef]="col.key">
            <mat-header-cell
              *matHeaderCellDef
              class="padding"
              [mat-sort-header]="col.key"
              [disabled]="!col.sortable"
              [ngClass]="columnClass(col)"
              [ngStyle]="columnWidthStyle(col)"
            >
              {{ col.label }}
            </mat-header-cell>
            <mat-cell
              *matCellDef="let row"
              class="padding"
              [ngClass]="columnClass(col)"
              [ngStyle]="columnWidthStyle(col)"
              [attr.title]="displayValue(row, col)"
            >
              {{ displayValue(row, col) }}
            </mat-cell>
            <mat-footer-cell
              *matFooterCellDef
              class="padding ctg-footer-cell"
              [ngClass]="columnClass(col)"
              [ngStyle]="columnWidthStyle(col)"
              [attr.title]="footerRow ? displayValue(footerRow, col) : ''"
            >
              {{ footerRow ? displayValue(footerRow, col) : '' }}
            </mat-footer-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
          <mat-footer-row
            *matFooterRowDef="displayedColumns; sticky: true"
            class="ctg-footer-row"
            [class.ctg-footer-row--hidden]="!hasFooter"
          ></mat-footer-row>
        </mat-table>

        <div class="ctg-empty" *ngIf="!visibleRows.length">
          {{ 'copilot.table.empty' | translate }}
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #peopleTable>
    <table
      mat-table
      [dataSource]="visibleRows"
      class="answer__people-table"
      matSort
      [matSortActive]="activeSortColumn || ''"
      [matSortDirection]="activeSortDirection"
      matSortDisableClear
      (matSortChange)="onSort($event)"
    >
      <ng-container *ngFor="let col of columns" [matColumnDef]="col.key">
        <th
          mat-header-cell
          *matHeaderCellDef
          [mat-sort-header]="col.key"
          [disabled]="!col.sortable"
          [class.answer__cell-right]="isMetricColumn(col)"
        >
          {{ col.label }}
        </th>
        <td
          mat-cell
          *matCellDef="let row"
          [class.answer__cell-right]="isMetricColumn(col)"
          [attr.title]="displayValue(row, col)"
        >
          {{ displayValue(row, col) }}
        </td>
        <td
          mat-footer-cell
          *matFooterCellDef
          [class.answer__cell-right]="isMetricColumn(col)"
          [attr.title]="footerRow ? displayValue(footerRow, col) : ''"
        >
          {{ footerRow ? displayValue(footerRow, col) : '' }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      <tr
        mat-footer-row
        *matFooterRowDef="displayedColumns"
        [class.answer__people-table-footer--hidden]="!hasFooter"
      ></tr>
    </table>

    <div class="ctg-empty" *ngIf="!visibleRows.length">
      {{ 'copilot.table.empty' | translate }}
    </div>
  </ng-template>

  <div class="ctg-footer" *ngIf="isTruncated">
    {{ 'copilot.table.truncated' | translate: { shown: maxRows, total: totalRowCount } }}
  </div>
</ng-container>
